/**
 * Ryan O'Dowd
 * 2018-04-16
 * © Copyright 2018 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  Platform,
} from 'react-native';

const getStyles = ({fonts, globalScale, colors, isDarkMode}) => {
  const textColor = isDarkMode ? colors.white : colors.primaryExtraDark;

  return {
    container: {
      width: '100%',
      marginVertical: 4,
    },
    learnMoreButtonText: {
      color: colors.white,
      fontFamily: fonts.primaryBold,
    },
    touchable: {
      display: 'flex',
      width: '100%',
      backgroundColor: isDarkMode ? colors.primaryExtraDark : colors.primaryLight,
      borderRadius: 24,
      padding: 12,
      paddingHorizontal: 16,
      borderStyle: 'solid',
      borderWidth: globalScale * 2,
      borderColor: isDarkMode ? colors.primary : colors.primaryDark,
    },
    text: {
      display: Platform.OS === 'web' ? 'block' : 'flex',
      fontSize: globalScale * 14,
      color: colors.white,
      fontFamily: fonts.primaryItalic,
    },
    titleText: {
      color: colors.white,
      fontSize: 16,
      fontFamily: fonts.primaryBold,
    },
    dialogText: {
      color: textColor,
      fontFamily: fonts.primary,
    },
    sectionTitle: { // @TODO: in the dialog...could probably be in commonStyles
      marginTop: globalScale * 16,
      fontSize: globalScale * 16,
      fontFamily: fonts.secondaryBold,
      color: textColor,
    },
    sectionWrapper: { // @TODO: in the dialog...could probably be in commonStyles
      padding: 8,
      paddingTop: 0,
    },
  };
};

export default getStyles;
